import { useCountdownTimerSectionContext } from "repoV2/pages/sale/contexts/CountdownTimerSectionContext";
import { checkIsArrayEmpty } from "repoV2/utils/common/dataTypes/array";
import { useCountdownTimer } from "repoV2/utils/common/time/countDownTimer";

export const useCountdownTimerSection = () => {
    const {
        dummyUnits,
        hide: hideTimer,
        hurryText,
        timeIsRunningOutText,
        useCountdownTimerHookProps,
        isTimerStarted,
        isPreview,
    } = useCountdownTimerSectionContext();
    const { startTime, endTime } = useCountdownTimerHookProps;
    const { units: timerUnits } = useCountdownTimer({
        start: new Date(startTime),
        end: new Date(endTime),
    });
    const hide = hideTimer || (isTimerStarted && checkIsArrayEmpty(timerUnits));
    const units = checkIsArrayEmpty(timerUnits) ? dummyUnits : timerUnits;
    return { units, hide, hurryText, timeIsRunningOutText, isPreview };
};
